<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划执行时间" prop="planTime">
              <j-date dateFormat="YYYY-MM-DD" placeholder="请选择计划执行时间" style="width: 100%" v-model="model.planTime" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际执行时间" prop="realTime">
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择实际执行时间"
                style="width: 100%"
                v-model="model.realTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际执行人" prop="finishName">
              <j-dict-select-tag
                :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                pageSize="100"
                placeholder="请选择实际执行人"
                type="list"
                v-model="model.finishId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="!model.id">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="保养设备" prop="deviceId">
              <!-- <j-select-device :multiple="true" @select="devIdChange" placeholder="请选择保养设备" v-model="model.deviceId" /> -->
              <j-tree-select-device
                :multiple="true"
                @change="devIdChange"
                placeholder="请选择保养设备"
                v-model="model.deviceId"
              ></j-tree-select-device>
            </a-form-model-item>
          </a-col>
          <!-- maintenanceIntervals -->
          <!-- <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="保养周期(天)"
              prop="maintenanceIntervals"
            >
              <a-input placeholder="请输入保养周期" v-model.number="model.maintenanceIntervals"></a-input>
            </a-form-model-item>
          </a-col>-->
        </a-row>
      </a-form-model>
    </j-form-container>
    <task-device-table
      :canEdit="canEdit"
      :dataSource="dataList"
      :repairPlanId="planId"
      @refresList="refresList"
      ref="tasktable"
      v-if="tableLoading"
    />

    <!-- 消耗得备品备件列表 -->
    <DevBpbjLeadoutRecordList :canEdit="canEdit" ref="devBpbjLeadoutRecordList"></DevBpbjLeadoutRecordList>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import DevBpbjLeadoutRecordList from './DevBpbjLeadoutRecordList'
  import JSelectDevicePlan from '../../../components/jeecgbiz/JSelectDevicePlan.vue'
  import TaskDeviceTable from './TaskPlanTable.vue'
  import { groupBy, uniqueId, clone, map, pick } from 'lodash';
  import moment from 'dayjs'
  import { omit } from 'lodash'
  import { postAction } from '../../../api/manage'

  export default {
    name: 'DevMaintainceTaskForm',
    components: {
      JSelectDevicePlan, TaskDeviceTable, DevBpbjLeadoutRecordList
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      canEdit: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        dataList: [],
        tableLoading: false,
        model: {
          planTime: moment().format('YYYY-MM-DD'),
          realTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          finishId: this.$store.getters.userInfo.id,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          realTime: [{ required: true, message: '请选择实际执行时间!' }],
          deviceId: [{ required: true, message: '请选择保养设备!' }],
        },
        repairPlanId: '',// 检修计划id
        url: {
          add: "/maintenance/devMaintainceTask/add",
          edit: "/maintenance/devMaintainceTask/edit",
          queryById: "/maintenance/devMaintainceTask/queryById",
          devTaskById: '/maintenance/devMaintainceTaskDeviceCompleteInfo/queryById',
          taskById: '/maintenance/devMaintainceTask/getDetailById',
          saveTask: '/maintenance/devMaintainceTask/saveOrFinishesDevMaintaince',
          addTask: '/maintenance/devMaintainceTask/saveTask'
        },
        selectDevices: []
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      planId () {
        return this.repairPlanId
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        // 调用 消耗备品备件列表数据

        if (record && record.id) {
          this.tableLoading = false
          this.dataList = []
          this.$refs.devBpbjLeadoutRecordList.getData(record.id)
          getAction(this.url.taskById, { id: record.id }).then(res => {
            this.tableLoading = true
            this.detailData = res.result
            if (res.result && res.result.list) {

              const grouped = groupBy(res.result.list, v => v.devName);

              // 其次合并，第一项占行，后续为0
              const result = Object.keys(grouped)
                .map(k => grouped[k].map((v, i, arr) => ({ ...v, uuid: uniqueId(), rowSpan: i === 0 ? arr.length : 0 })))
                .flatMap(v => v);
              this.dataList = result

              this.repairPlanId = res?.result?.id
            }
          })
        } else {
          record.finishId = this.$ls.get('Login_UserId')
          record.realTime = moment().format('YYYY-MM-DD HH:mm:ss')
          this.validatorRules['deviceId'] = [{ required: true, message: '请选择保养设备!' }]
        }
        this.model = Object.assign({}, record);


        this.visible = true;
      },
      async devIdChange (devId, device, d) {


        // device.map(dev => dev.id = dev.value);
        const devIds = device.map(dev => dev.value)
        if (device.length === 0) {
          this.dataList = []
          this.detailData = []
          this.$refs.tasktable?.tableListChange([])
          this.$refs.devBpbjLeadoutRecordList?.clear()
          return
        }
        // const params = map(device, 'id').join()

        const { success, result } = await getAction('/maintenance/devMaintenanceStl/queryStlSubByDevIds', { devIds: devIds.join() })
        if (success) {
          this.detailData = result

          // const resultDeviceById = await postAction('/device/devList/getDevListByIds', devIds)

          const grouped = groupBy(clone(result), v => v.devName);
          // 其次合并，第一项占行，后续为0
          // pick 寻找devId对应的devClassId
          // ..pick(resultDeviceById.result.find(d => d.id === v.devId), 'devClassId')
          const resultData = Object.keys(grouped)
            .map(k => grouped[k].map((v, i, arr) => ({ ...v, uuid: uniqueId(), rowSpan: i === 0 ? arr.length : 0 })))
            .flatMap(v => v);

          this.dataList = resultData
          this.tableLoading = true
          if (this.$refs.tasktable) {
            this.$refs.tasktable.tableListChange(resultData)
          }

          //   this.repairPlanId = res?.result?.id

        }

      },
      clearData () {

        // this.$refs.tasktable?.tableListChange([]);

        // this.$refs.devBpbjLeadoutRecordList?.clear()

      },
      submitForm (type) {
        const that = this;

        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            let httpurl = '';
            let method = '';
            if (that.model.planTime) that.model.planTime = that.model.planTime + ' 00:00:00'
            let countExecute = false

            const cloneDeviceTableData = that.$refs.tasktable.getDataList()

            const params = {
              ...this.model,
              list: cloneDeviceTableData.reduce((pre, cur) => {
                if (cur.isExecute && !countExecute) countExecute = true
                pre.push(omit(cur, ['rowSpan', 'uuid']))
                return pre
              }, []),
              taskStatus: type
            }
            that.confirmLoading = true;
            if (!this.model.id) {
              if (!countExecute) {
                this.$message.error('至少执行一项保养操作')
                that.confirmLoading = false;
                return
              }
              httpurl += this.url.addTask;
              method = 'post';
              params.bpbjLeadoutList = this.$refs.devBpbjLeadoutRecordList.dataSource.map(map => omit(map, ['id']))
            } else {
              httpurl += this.url.saveTask;
              method = 'put';
              params.leadoutList = this.$refs.devBpbjLeadoutRecordList.dataSource.map(map => omit(map, ['id']))
            }



            httpAction(httpurl, params, 'post').then((res) => {
              if (res.success) {
                that.$message.success('保存成功');
                that.$emit('ok');
              } else {
                that.$message.warning('保存失败');
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      refresList (list) {

        // if (!this.model.id) {
        // list
        const recordList = this.$refs.devBpbjLeadoutRecordList.dataSource
        this.$refs.devBpbjLeadoutRecordList.dataSource = recordList.concat(list)
        //   } else {
        // this.$refs.devBpbjLeadoutRecordList.getData(this.planId)
        // const recordList = this.$refs.devBpbjLeadoutRecordList.dataSource
        // this.$refs.devBpbjLeadoutRecordList.dataSource = recordList.concat(list)
        // this.$refs.devBpbjLeadoutRecordList.getData(this.planId)
        // this.$nextTick(() => {
        //   const recordList = this.$refs.devBpbjLeadoutRecordList.dataSource
        //   this.$refs.devBpbjLeadoutRecordList.dataSource = recordList.concat(list)
        // })
        // }
      }
    }
  }
</script>